var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440.614,
    height: 232.256,
    viewBox: "0 0 440.614 232.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(-884 -340.565)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 143.514,
    cy: 18.228,
    rx: 143.514,
    ry: 18.228,
    transform: "translate(953.377 536.365)",
    fill: "#9d9d9d",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 246.497,
    height: 160.909,
    transform: "translate(1218.74 554.616) rotate(180)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M839.642,518.45h-246.5l-15.566,35.541H858.1Z",
    transform: "translate(379.098 -124.743)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1018.149,976.346l-1.3-1.521c3.7-3.159,12.039-6.38,21.76-8.4a98.975,98.975,0,0,1,14.871-1.953,61.924,61.924,0,0,1,14.261.749,29.309,29.309,0,0,1,9.006,3.056,15.05,15.05,0,0,1,6.035,5.863l-1.757.956c-2.161-3.972-6.753-6.633-13.648-7.909-7.613-1.409-17.95-.973-28.361,1.2a84.3,84.3,0,0,0-12.706,3.635A29.384,29.384,0,0,0,1018.149,976.346Z",
    transform: "translate(46.095 -463.038)",
    fill: "#0a1e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    d: "M7.048-1A8.048,8.048,0,1,1-1,7.048,8.057,8.057,0,0,1,7.048-1Zm0,14.1A6.048,6.048,0,1,0,1,7.048,6.055,6.055,0,0,0,7.048,13.1Z",
    transform: "translate(1144.648 479.251)",
    fill: "#0a1e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    d: "M7.048-1A8.048,8.048,0,1,1-1,7.048,8.057,8.057,0,0,1,7.048-1Zm0,14.1A6.048,6.048,0,1,0,1,7.048,6.055,6.055,0,0,0,7.048,13.1Z",
    transform: "translate(1032.122 479.251)",
    fill: "#0a1e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M306.432,474.909c-.875,0-1.825-.038-2.83-.136a26.032,26.032,0,0,1-6.948-1.624,22.784,22.784,0,0,1-7.164-4.448,24.517,24.517,0,0,1-7.484-13.99,23.933,23.933,0,0,1,2.464-15.422,26.469,26.469,0,0,1,7.956-8.815,19.072,19.072,0,0,1,5.981-2.789,15.549,15.549,0,0,1,7-.208,18.917,18.917,0,0,1,10.167,5.935,15.68,15.68,0,0,1,4.185,11.284,16.832,16.832,0,0,1-1.1,5,17.8,17.8,0,0,1-2.617,4.626,12.245,12.245,0,0,1-9.186,4.988,12.941,12.941,0,0,1-6.039-1.39,15.209,15.209,0,0,1-4.84-3.747,11.787,11.787,0,0,1-2.209-3.76,7.974,7.974,0,0,1-.36-4.153c.539-2.809,2.886-5.629,5.981-7.185a8.089,8.089,0,0,1,7.1-.484c3.081,1.488,4.385,5.336,4.566,8.179.166,2.617-.532,4.7-1.867,5.566s-3.273.595-5.789-.794a25.754,25.754,0,0,1-3.6-2.462l1.269-1.546c2.534,2.081,5.857,3.884,7.025,3.124.555-.361,1.093-1.693.961-3.763-.158-2.487-1.283-5.463-3.44-6.5a6.142,6.142,0,0,0-5.329.47c-2.52,1.267-4.5,3.587-4.915,5.774a7.716,7.716,0,0,0,2.127,6.239,12.373,12.373,0,0,0,9.3,4.434c6.144-.184,10.633-6.731,10.97-12.729.433-7.7-6.279-13.855-12.747-15.145-9.167-1.828-16.3,6.274-18.789,10.813-4.731,8.625-2.746,20.221,4.618,26.975a21.77,21.77,0,0,0,12.952,5.556,26.459,26.459,0,0,0,7.6-.343l.418,1.956A26.707,26.707,0,0,1,306.432,474.909Z",
    transform: "translate(602.341 -56.408)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1919.01,993.879q-.955,0-1.914-.073a23.932,23.932,0,0,1-14.382-6.088,26.467,26.467,0,0,1-6.652-9.837,19.073,19.073,0,0,1-1.274-6.475,15.55,15.55,0,0,1,1.475-6.843,18.916,18.916,0,0,1,8.2-8.448,15.682,15.682,0,0,1,11.958-1.359,16.832,16.832,0,0,1,4.591,2.27,17.805,17.805,0,0,1,3.864,3.65,12.244,12.244,0,0,1,2.641,10.114,12.937,12.937,0,0,1-2.8,5.53,15.206,15.206,0,0,1-4.8,3.8,11.786,11.786,0,0,1-4.18,1.244,7.976,7.976,0,0,1-4.119-.646c-2.6-1.2-4.774-4.152-5.542-7.529a8.088,8.088,0,0,1,1.231-7.005c2.182-2.635,6.23-2.979,9.034-2.473,2.581.466,4.434,1.642,4.958,3.147s-.207,3.32-2.158,5.43a25.757,25.757,0,0,1-3.252,2.9l-1.2-1.6c2.628-1.962,5.174-4.756,4.717-6.071-.217-.626-1.382-1.467-3.424-1.835-2.453-.443-5.611-.064-7.139,1.781a6.142,6.142,0,0,0-.821,5.286c.626,2.75,2.405,5.224,4.428,6.156a7.717,7.717,0,0,0,6.568-.57,12.37,12.37,0,0,0,6.532-7.963c1.294-6.009-3.986-11.936-9.729-13.7-7.37-2.266-14.956,2.776-17.758,8.745-3.972,8.462,2.184,17.328,5.995,20.833,7.239,6.66,18.974,7.512,27.3,1.981a21.77,21.77,0,0,0,8.5-11.243,26.426,26.426,0,0,0,1.488-7.459l2,.062a28.135,28.135,0,0,1-1.6,8.06,26.032,26.032,0,0,1-3.242,6.356,22.784,22.784,0,0,1-6.036,5.889A24.376,24.376,0,0,1,1919.01,993.879Z",
    transform: "translate(-618.735 -455.288)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(976.952 340.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_144",
    "data-name": "Line 144",
    d: "M1,20.9H-1V0H1Z",
    transform: "translate(10.451)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_145",
    "data-name": "Line 145",
    d: "M20.9,1H0V-1H20.9Z",
    transform: "translate(0 10.451)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274",
    transform: "translate(926.221 482.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_146",
    "data-name": "Line 146",
    d: "M7.556,8.97-.707.707.707-.707,8.97,7.556Z",
    transform: "translate(0)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_147",
    "data-name": "Line 147",
    d: "M.707,8.97-.707,7.556,7.556-.707,8.97.707Z",
    transform: "translate(0)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1761.519,934.827l-3.159,4.551a10.171,10.171,0,0,0,0,11.591l3.158,4.55-4.55-3.158a10.172,10.172,0,0,0-11.592,0l-4.549,3.157,3.158-4.549a10.171,10.171,0,0,0,0-11.591l-3.158-4.55,4.55,3.158a10.172,10.172,0,0,0,11.592,0Zm-10.346,6.972a12.145,12.145,0,0,1-4.073-.7,12.225,12.225,0,0,1,0,8.147,12.224,12.224,0,0,1,8.147,0,12.224,12.224,0,0,1,0-8.147A12.148,12.148,0,0,1,1751.173,941.8Z",
    transform: "translate(-504.448 -442.937)",
    fill: "#dedede"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemFound);
export default __webpack_public_path__ + "static/media/no-item-found.ac74bb7310bf69882cfc5d6abaf90bd2.svg";
export { ForwardRef as ReactComponent };